import { AfterViewInit, Component, ContentChildren, OnInit, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { TableHeaderComponent } from '../table-header/table-header.component';

@Component({
  selector: 'ff-table-head',
  templateUrl: './table-head.component.html',
  styleUrls: ['./table-head.component.scss']
})
export class TableHeadComponent implements OnInit, AfterViewInit {

  // List of header child component elements
  public headerTemplates: QueryList<TableHeaderComponent>;
  @ContentChildren(TableHeaderComponent) headers: QueryList<TableHeaderComponent>;

  // Self-template reference
  @ViewChild('headTemplate') template: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => this.headerTemplates = this.headers);
  }

}
